import gql from 'graphql-tag'

export const getThirdParties = gql`
  query($filter: ThirdPartiesFilter!, $paging: PagingQuery, $order: ThirdPartiesOrder) {
    getThirdParties(
      filter: $filter,
      order: $order,
      paging: $paging
    ) {
      thirdParties {
        id
        name
        phone
        phoneExtensionNumber
        phoneCountryCode
        phoneCountryCallingCode
        fax
        faxExtensionNumber
        faxCountryCode
        faxCountryCallingCode
        email
        notes
      }
      paging { totalCount currentOffset currentLimit }
    }
  }
`

export const getThirdParty = gql`
  query($thirdPartyId: Int!) {
    getThirdParty(
      thirdPartyId: $thirdPartyId
    ) {
      id
      name
      phone
      phoneExtensionNumber
      phoneCountryCode
      phoneCountryCallingCode
      fax
      faxExtensionNumber
      faxCountryCode
      faxCountryCallingCode
      email
      notes
      createdAt
      updatedAt
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
    }
  }
`

export const newThirdParty = gql`
  mutation($thirdPartyInput: ThirdPartyInput!) {
    newThirdParty(
      thirdPartyInput: $thirdPartyInput
    ) {
      id
    }
  }
`

export const editThirdParty = gql`
  mutation($thirdPartyInput: ThirdPartyInput!, $thirdPartyId: Int!) {
    editThirdParty(
      thirdPartyId: $thirdPartyId,
      thirdPartyInput: $thirdPartyInput
    ) {
      id
    }
  }
`

export const deleteThirdParty = gql`
  mutation($thirdPartyId: Int!) {
    deleteThirdParty(
      thirdPartyId: $thirdPartyId
    )
  }
`
